module.exports = __webpack_public_path__ + "img/money.1e3a640b.svg";